export function Brand({ compact = false }: { compact?: boolean }) {
  return <div className={`brand ${compact ? "brand--compact" : ""}`}><span className="brand__mark">PR</span><span><strong>PACHARAKRIT</strong><small>TIME ATTENDANCE FAST TRACK</small></span></div>;
}
